export const CUBE_LAYER_TYPE = {
  BASELINE: 'BASELINE',
  ACTUAL: 'ACTUAL',
  GENERAL: 'GENERAL',
};
export const CUBE_PERCENTAGE_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  HEADING: 'HEADING',
};

export const CUBE_SYNC_STATUS = {
  REQUIRED: 'REQUIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const CUBE_EVENT_SYNC_STATUS = {
  REQUIRED: 'REQUIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const CUBE_ACTIVITY_STATUS = {
  READY: 'READY',
  CALCULATING: 'CALCULATING',
  RECALCULATING: 'RECALCULATING',
  CALCULATION_FAILED: 'CALCULATION_FAILED',
};

export const CUBE_TIME_PERIOD_TYPE = {
  YEAR: 'YEAR',
  QUARTER: 'QUARTER',
  MONTH: 'MONTH',
  WEEK: 'WEEK',
};
export const CUBE_PULL_TOTALING_RULE = {
  LAST_WEEK_IN_MONTH: 'LAST_WEEK_IN_MONTH',
  ALL_WEEKS_IN_MONTH: 'ALL_WEEKS_IN_MONTH',
  ALL_WEEKS_IN_QUARTER: 'ALL_WEEKS_IN_QUARTER',
  ALL_WEEKS_IN_YEAR: 'ALL_WEEKS_IN_YEAR',
};

// Coarsest (largest) to finest (smallest). Used to decide when a source period is larger than a destination
// period (e.g. pulling YEAR data into a MONTH cube), which requires a spread policy.
export const CUBE_TIME_PERIOD_SIZE_ORDER = [
  CUBE_TIME_PERIOD_TYPE.YEAR,
  CUBE_TIME_PERIOD_TYPE.QUARTER,
  CUBE_TIME_PERIOD_TYPE.MONTH,
  CUBE_TIME_PERIOD_TYPE.WEEK,
];

// How a single source value is spread across the (finer) destination periods it covers, when the source
// period is larger than the destination period in the "Map Data From Cube to Cube" rule.
export const CUBE_MAP_DATA_SPREAD_MODE = {
  DUPLICATE: 'DUPLICATE',
  PROPORTIONAL: 'PROPORTIONAL',
};
